function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialYoutube = function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M38.371 4.314a4.805 4.805 0 0 0-1.239-2.18A4.57 4.57 0 0 0 34.929.872C34.164.658 32.94.49 31.257.367a285.044 285.044 0 0 0-5.141-.229 127.083 127.083 0 0 0-4.544-.092L19.599 0l-1.974.046c-1.316 0-2.83.023-4.544.069-1.713.046-3.427.114-5.141.206-1.683.123-2.906.291-3.671.505a4.715 4.715 0 0 0-2.181 1.262A4.715 4.715 0 0 0 .826 4.269C.398 5.829.153 7.795.092 10.167A9751.85 9751.85 0 0 1 0 13.724l.092 3.58c.061 2.386.29 4.329.688 5.829a4.565 4.565 0 0 0 1.262 2.203 5.198 5.198 0 0 0 2.181 1.285c.795.184 2.034.337 3.717.459 1.683.122 3.389.214 5.118.275 1.729.062 3.251.092 4.567.092h3.901c1.316 0 2.838-.023 4.567-.069 1.729-.045 3.435-.13 5.118-.252 1.683-.092 2.907-.245 3.672-.459a4.565 4.565 0 0 0 2.203-1.262 5.194 5.194 0 0 0 1.285-2.18c.398-1.53.635-3.489.712-5.875l.114-3.58-.092-3.581c-.061-2.386-.306-4.345-.734-5.875Zm-22.72 15.285.046-11.75 10.19 5.875-10.236 5.875Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(.6123 0 0 .6123 0 4)"
  }));
};
export default SvgSocialYoutube;